import { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Axios from 'axios';
import { useNavigate } from 'react-router'; 
// @mui
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';
// auth
import { useAuthContext } from 'src/auth/hooks';
// api
import { handleApiAction } from 'src/utils/handleApiAction';
import { fetchSubscriptionWithUserID, sendMail } from 'src/components/subscription/api/services';
// components
import { ConfirmDialog } from 'src/components/custom-dialog';// hooks
import { useBoolean } from 'src/hooks/use-boolean';

import { useSnackbar } from 'src/components/snackbar';
// utils
import { fPercent } from 'src/utils/format-number';
import { FormShareContext, SubscriptionContext } from 'src/context/Context';
import CallAction from './call-action';

// ----------------------------------------------------------------------

export default function NavUpgrade({ organisme }) {

  const { user, logout } = useAuthContext();

  const navigate = useNavigate();

  const confirm = useBoolean();

  const { enqueueSnackbar } = useSnackbar();

  const reload = useContext(FormShareContext);
  const subscr = useContext(SubscriptionContext);

  const [trainees , setTrainees]= useState(0);
  const [activePlan, setActivePlan] = useState([]);
  const [isPremium, setIsPremium] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [subscription, setSubscription] = useState([]);
  const [totalTrainees , setTotalTrainees]= useState(0);
  const [subscriptionValide , setSubscriptionValide]= useState(false);

  const administrator = user.role === "administrator";

  const offreID = subscription[0]?.offreID;


  const handlefetchSubscription = (userID) =>{
    const opt = {
      onAuthRequired: async () => {
        enqueueSnackbar('Session expirée. Veuillez vous reconnecter.', { variant: 'warning' });
        await logout();
      },
    };

    fetchSubscriptionWithUserID(userID, opt )
    .then((response)=>{ 
        setTrainees(response.data.trainees);
        setSubscription(response.data.plans);
        setTotalTrainees(response.data.totalTrainee);
        setSubscriptionValide(response.data.subscription);
        setIsLoading(true);
        if(response.data.sendMail){
          confirm.onTrue();
          handleSendMail(userID);
        }
    })
    .catch((err)=>{ console.error(err); })
  }

  const handleSendMail = (userID) =>{

    const payload = {userID};

    handleApiAction({
      action: sendMail,
      payload,
      onSuccess: () => {},
      enqueueSnackbar,
      logout,
    });  
  }

  const handleClic = () =>{

    if(administrator){
      navigate(`/subscriptions/admin/pricing`, {state:{
        offreID, 
        organisme,
        preview: false, 
        returnTab: "tabsubcrip",
        administrator,
      }});
    }else{
      navigate(`/subscriptions/pricing`, {state:{
        offreID, 
        returnTab: "subscription",
      }});
    }

  }

  const handleMoreThan = () => {
    const subject = encodeURIComponent("Plus de 250 apprenants par an.");
    const body = encodeURIComponent(
      "Bonjour l’équipe Postgrad,\n\nSeriez-vous disponible prochainement pour convenir d’une offre sur mesure pour mon organisme de formation ?\n\nÀ bientôt !"
    );
  
    window.location.href = `mailto:contact@postgrad.fr?subject=${subject}&body=${body}`;
  };

  useEffect(()=>{
    if(reload.reloadModalShare){
      handlefetchSubscription(user.id);
      reload.updateReloadModalShare(false);
    }
    // eslint-disable-next-line
  },[reload.reloadModalShare]);

  useEffect(()=>{
    const test = activePlan.filter((item)=>item.type === "premium");
    setIsPremium(test.length !== 0);

    if(activePlan.length !== 0 ){
      subscr.updateOffreID(offreID);
    }
    
    // eslint-disable-next-line
  },[activePlan]);

  useEffect(()=>{

    let test = false;
    const remainingTrainees = parseInt(totalTrainees, 10) - parseInt(trainees, 10);

    setActivePlan(subscription.filter((item)=>item.status === "inProcess"));

    if(totalTrainees === trainees)test = true;
    else if(totalTrainees < trainees)test = true;


    subscr.updateActivePlan(subscriptionValide);
    subscr.updateAbonnement(subscription.length !== 0)
    subscr.updateSubscription(test);
    subscr.updateRemainingTrainees(remainingTrainees>=0 ? remainingTrainees : 0);

    // eslint-disable-next-line
  },[subscription]);

  useEffect(()=>{
    if(user?.id !== "" && organisme === undefined)handlefetchSubscription(user?.id);
    if(organisme !== undefined)handlefetchSubscription(organisme?.id);
    // eslint-disable-next-line
  },[user, organisme]);
  

  return (
    <>
      {
        (subscription.length !== 0 && user.role === "organization") && (

          <Stack
            sx={{
              pt: administrator ? 2 : 0,
              pb: administrator ? 3 : 0,
              my: administrator ? 0 : 2,
              textAlign: 'center',
            }}
          >
            <Stack alignItems="center" >
        
              {subscriptionValide && 
                <>
                  {
                    ! administrator &&
                    <ProgressItem 
                      trainees={trainees}
                      totalTrainees={totalTrainees}
                    />
                  }
                </>
              }              

              {
                !isPremium 
                ? <Button variant="contained" onClick={()=>handleClic()}>
                    {activePlan.length !== 0 ? "Mettre à jour l'abonnement" : "Souscrire à un abonnement" }
                  </Button>
                : <Button variant="contained" onClick={()=>handleMoreThan()}>
                    Plus de 250 apprenants
                  </Button>
              }
              
            </Stack>
          </Stack>
        )
      }

      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Motification"
        content="Votre abonnement arrivera à échéance dans un mois. Nous vous invitons à procéder à son renouvellement afin de garantir la continuité de votre service."
      />
    </>

  );
}

NavUpgrade.propTypes = {
  organisme: PropTypes.object,
};

function ProgressItem({ trainees, totalTrainees }) {


  const totalTrainee = totalTrainees > 0 ? totalTrainees : 1;  
  const test = trainees > totalTrainee;
  const pourcentage = test ? 100 : (trainees / totalTrainee) * 100;

  return (
    <Stack spacing={1} sx={{mb:2}}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">

        <Typography variant="caption" noWrap sx={{ color: 'text.disabled', mr:1 }}>
          Nombre de stagiaires
        </Typography>

        <Stack direction="row" alignItems="center">
          <Typography variant="body2">{trainees}</Typography>
          {
            pourcentage === 0 
            ?  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                 &nbsp; (0%)
              </Typography>

            :  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                &nbsp;({fPercent(pourcentage)})
              </Typography>
          }
        
        </Stack>
      </Stack>

      <LinearProgress
        variant="determinate"
        value={pourcentage}
        color={test ? 'error' : 'primary'}
      />
    </Stack>
  );
}

ProgressItem.propTypes = {
  trainees: PropTypes.number,
  totalTrainees: PropTypes.number,
};
